import Slider from './Slider';
import Carousel from './Carousel';
import masks from './masks';
import Lightbox from './Lightbox';
import {request} from './form';
import {
  _map,
  screen,
  _toggle,
  _show,
  createElement,
  _hide
} from './helpers';

const sliderOptions = {
  autoplay: slider => {
    slider
      .play()
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play());
  }
};

addEventListener('load', function(){  
  _toggle('.container-carousel', '#loader');
});

function setup() {

  document.body.addEventListener("touchstart", function () {
    return false
  });

  const formulario = document.querySelector('#formcontato');

  formulario.addEventListener('submit', function(e){
    e.preventDefault();
     const dados = new FormData();
     _map(formulario.elements, input => dados.append(input.name, input.value));     
     const requisicao = request('get', 'api/Email/EmailContato?nome=' 
      + document.getElementById('nome').value + '&email=' 
      + document.getElementById('email').value + '&telefone=' 
      + document.getElementById('telefone').value + '&celular=' 
      + document.getElementById('celular').value + '&assunto=' 
      + document.getElementById('assunto').value + '&mensagem=' 
      + document.getElementById('mensagem').value, dados);
    
    requisicao.onload = ()=>{
      const resposta = requisicao.responseText;      
        const msg = createElement("small", {
          innerHTML: resposta==="erro" ? "Houve um erro ao enviar a mensagem" : "Sua mensagem foi enviada com sucesso!",
          className: "post-img sucesso"
        });        
      formulario.appendChild(msg);      
      setTimeout(function () { msg.parentElement.removeChild(msg) }, 3000);
      formulario.reset();
    };
    
    requisicao.send();        
  });

  window.sliders = _map('.slider', parent => {
    const slider = new Slider({
      parent
    });
    configSlider(slider, parent);
  });

  window.carousels = _map('.carousel', parent => {
    const size = parent.getAttribute('data-size') | 0;
    const carousel = new Carousel({
      parent,
      size
    });
    configSlider(carousel, parent);
    return carousel;
  });

  _map('[data-mask]', campo => {
    const name = campo.getAttribute('data-mask');
    if (!name) return;
    if (!masks[name] || !(masks[name] instanceof Function)) return;
    campo.addEventListener('input', function () {
      masks[name](campo);
    });
  });

  _map('[data-script]', item => {
    const valueFn = item.getAttribute("data-script");
    if (!valueFn) return;
    if (!item.value) return;
    window[valueFn](0, item.value);
  });  

  var lightbox = new Lightbox("[data-lightbox]");

  var links = _map('[data-categoria]');
  links.forEach(link => {
    link.addEventListener('click', function(){
      const categoria = link.getAttribute('data-categoria');
      if (!categoria) return;
      selectSlider(categoria);
    });
  });

  function selectSlider(categoria) {
    _hide('[data-produto]');
    _show(`[data-produto="${categoria}"]`);

    const tabs = _map('.product-tab');
    tabs.forEach(tab => {
      if (tab.getAttribute('data-categoria') === categoria) {
        tab.classList.add('active');
        return;
      }
      tab.classList.remove('active');
    });
  }

  const offsetHeader = document.querySelector('.site-header').offsetHeight;
  const pageLinks = document.querySelectorAll('a[href^="#"].scroll');
  Array.prototype.forEach.call(pageLinks, link => link.addEventListener("click", function(){
      const section = document.querySelector(this.hash);
      if (!section) return false;
      scrollToY(section.offsetTop - offsetHeader, 1000);
  }));  
  
  // for (var i = 0 ; i < linkOculos.length; i++) {    
  //   linkOculos[i].addEventListener('click', () =>{
  //       const categoria = document.querySelectorAll('[data-produto]');
  //       console.log(categoria);
  //       console.log(linkOculos[i]);
  //       for(var c = 0; c < categoria.length; c++ )
  //       {
  //         categoria[0].setAttribute('hidden', '');
  //         categoria[1].setAttribute('hidden', '');
  //       }

  //       if(linkOculos[i].hash == "#oculos-sol"){
  //         categoria.removeAtributte('hidden');
  //       }
  //       else if(linkOculos[i].hash == "#oculos-grau"){
  //         categoria.removeAtributte('hidden');
  //       }
  //       else {
  //       }
        
  //   });
  // };  
}

window.setup = setup;

function configSlider(slider, parent) {
  const first = parent.getAttribute('data-first') | 0;
  if (first) {
    slider.goTo(first);
  }

  const options = parent.hasAttribute('data-options') ? parent.getAttribute('data-options').split(' ') : [];
  options.forEach(option => sliderOptions[option] && sliderOptions[option](slider));

  const sliderCallbacks = {
    openOnMobile: () => {
      if (screen().width > 600) return;
      const first = slider.find(slide => slide.getAttribute('data-order') === '0');
      if (!first) return;
      const btn = first.querySelector('.info-img a[href^="javascript:"]');
      if (!btn) return;
      btn.click();
    }
  };

  _map('[data-control]', control => {
    const target = control.getAttribute('data-control');
    const targetElement = target ? document.querySelector(target) : null;

    if (targetElement && targetElement === slider.parent) {
      const action = control.getAttribute('data-action');
      if ((action === 'prev' || action === 'next') && (slider.size >= slider.length)) {
        control.setAttribute('data-oversize', true);
      }
      const actionData = control.getAttribute('data-params');
      const params = actionData ? actionData.split(',') : null;
      const callback = control.getAttribute('data-callback');
      if (action && slider[action] instanceof Function) {
        control.addEventListener('click', function () {
          slider[action].apply(slider, params);
          if (callback && sliderCallbacks[callback]) sliderCallbacks[callback]();
        });
      }
    }

  });
}

window.modalFilme = function modalFilme(modal) {
  // if (screen().width < 600) return;
  return modal(modal);
};

window.modal = function modal(modal) {
  if (typeof modal === 'string') modal = document.querySelector(modal);
  return {
    abrir: function() {modal.classList.add('target');},
    fechar: function() {modal.classList.remove('target');}
  };
};

window.modalFilme = function modalFilme(modal) {
  if (typeof modal === 'string') modal = document.querySelector(modal);
  const modalComponent = window.modal(modal);
  if (screen().width < 800) {
    const btn = modal.querySelector('[data-btn="link-filme-interna"]');
    if (btn) {
      modalComponent.abrir = function() {location.assign(btn.href)};
    }
  }
  return modalComponent;
};

